export default "__VITE_ASSET__729b7594__"